import { getEnv } from '@/utils/utils'

export const serverNow = state => state.system.serverNow
export const zbid = state => state.zbid
export const wxconfig = state => state.wxconfig
export const vzandesc = state => state.vzandesc
export const userInfo = state => state.userInfo
export const isSignIn = state => state.isSignIn
export const isSignUp = state => state.isSignUp
export const isUserNoPayment = state => state.isUserNoPayment
export const isTicket = state => state.isTicket
export const playbackType = state => state.playbackType
export const expoActivity = state => state.expoActivity
export const expoHasLive = state => state.expoHasLive
export const audioPlaying = state => state.audioPlaying
export const zbvd = state => state.zbvd
export const isPrivateDomain = state => state.isPrivateDomain
export const storeStyleInfo = state => state.storeStyleInfo
export const isMiniProgram = state => state.isMiniProgram
export const customConfig = state => state.customConfig
export const orderFilterParams = state => state.orderFilterParams
export const orderFilterParamsNew = state => state.orderFilterParamsNew
export const couponFilterParams = state => state.couponFilterParams
export const couponFilterParamsNew = state => state.couponFilterParamsNew
export const goodsFilterParams = state => state.goodsFilterParams
export const goodsFilterParamsNew = state => state.goodsFilterParamsNew
export const showedBindStorePopup = state => state.showedBindStorePopup
export const mallConfig = state => state.shop.mallConfig
export const getAuthDataAndAgentSetting = state => {
  const isAdmin = (
    getEnv() == 'prod' ? ['CREATOR', 'ADMIN'] : ['CREATOR', 'ADMIN']
  ).some(v => (state.userInfo.roles || []).includes(v))
  // 是管理员且不是代理员
  const isAdminNotAgent = isAdmin && !state.authDataAndAgentSetting.isAgent
  return { ...state.authDataAndAgentSetting, isAdminNotAgent, isAdmin }
}
export const getAgentAuthList = state => state.agentAuthList
export const getIsAgentGray = state => state.isAgentGray
export const getIsAgent = state => state.isAgent
export const getIsForBiddenLive = state => state.isForBiddenLive
export const getPersonalBalance = state => state.personalBalance
export const guokeCustomization = state => state.guokeCustomization

export const cachedComponents = state => state.cachedComponents

/** 是否为团队负责人 */
export const isTeamLeader = state => {
  return state.agentTeamConfig.isLeader
}

/** 当前已选身份 为团队负责人 */
export const isLeaderIdentity = state => {
  return state.agentTeamConfig.isLeader && state.agentTeamConfig.roleType === 1
}

/** 当前已选身份 为团队代理业务员 */
export const isTeamAgentIdentity = state => {
  return state.agentTeamConfig.isLeader && state.agentTeamConfig.roleType === 2
}
export const integral = state => state.integral

/**
 * * 当前门店经营状态：
 * * 0未绑定负责人，1营业中，2已打烊
 */
export const storeBusinessStatus = state => state.vzanStore.storeBusinessStatus
export const getSelfVerifyConfig = state => state.selfVerifyConfig

/** *
 *代理设置字体大小
 */
export const fontSizeScale = state => state.fontSizeScale
export const isSupportFreightInsurance = state =>
  state.isSupportFreightInsurance
/** 允许使用会员功能的直播间 */
export const isAllowMember = state => {
  const zbvd = state.zbvd
  // // 尊享版、权益版、旗舰版才支持会员功能
  // const isVersion = zbvd.customerType == 6 && [0, 18, 20].includes(zbvd.applyId)
  // 会员功能只跟scrm开关有关
  return zbvd.isMemberShipLevel
}

/**
 * * 当前区域、分公司状态：0禁用，1启用
 */
export const storeStatus = state => state.vzanStore.storeStatus
// 用户跟进人数据
export const followInfoCache = state => state.followInfoCache

export const payThirdType = state => state.payThirdType
/**
 * 获取ERP模块的状态
 */
export const erp = state => state.erp

export const iBanShareInline = state => state.iBanShareInline
